import React from 'react';
import { motion } from 'framer-motion';
const points = [{
  text: 'Designed before it is sold',
  color: '#6366F1'
}, {
  text: 'Engineered, not assembled',
  color: '#EC4899'
}, {
  text: 'Invisible when not in use',
  color: '#F59E0B'
}, {
  text: 'Effortless to operate',
  color: '#10B981'
}, {
  text: 'Built to evolve over time',
  color: '#8B5CF6'
} // gaming
];
export function Difference() {
  return <section className="py-32 bg-void relative border-t border-graphite overflow-hidden" data-id="element-272">
      {/* Subtle radial gradient background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl max-h-4xl rounded-full blur-[150px] opacity-5 pointer-events-none" style={{
      background: 'radial-gradient(circle, #6366F1, #EC4899, #F59E0B, transparent)'
    }} data-id="element-273" />

      <div className="max-w-3xl mx-auto px-6 md:px-12 relative z-10" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-24" data-id="element-275">
          <h2 className="text-headline font-serif text-platinum" data-id="element-276">
            Most systems are installed.
            <br data-id="element-277" />
            <span className="text-gradient-vibrant" data-id="element-278">Ours are composed.</span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-279">
          {/* Vertical Line */}
          <div className="absolute left-4 top-4 bottom-4 w-px bg-graphite" data-id="element-280" />

          <div className="space-y-16" data-id="element-281">
            {points.map((point, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-10%'
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="flex items-center" data-id="element-282">
                {/* Dot */}
                <div className="relative z-10 w-8 h-8 flex items-center justify-center shrink-0 mr-8" data-id="element-283">
                  <div className="w-3 h-3 rounded-full shadow-[0_0_15px_currentColor]" style={{
                backgroundColor: point.color,
                color: point.color
              }} data-id="element-284" />
                  <div className="absolute inset-0 rounded-full opacity-20 animate-pulse" style={{
                backgroundColor: point.color
              }} data-id="element-285" />
                </div>

                {/* Text */}
                <h3 className="text-2xl md:text-title font-serif text-platinum" data-id="element-286">
                  {point.text}
                </h3>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}